import React, { useState } from 'react';
import { User } from 'lucide-react';

interface V11UserAvatarProps {
  src?: string;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const V11UserAvatar: React.FC<V11UserAvatarProps> = ({
  src,
  name = 'User',
  size = 'md',
  className = ''
}) => {
  const [imgError, setImgError] = useState(false);

  const sizeClasses = {
    sm: 'h-6 w-6 text-xs',
    md: 'h-8 w-8 text-sm',
    lg: 'h-10 w-10 text-base'
  };

  const getInitials = (fullName: string): string => {
    return fullName
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const baseClasses = `${sizeClasses[size]} rounded-full flex items-center justify-center font-medium ${className}`;

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={`${name} avatar`}
        className={`${baseClasses} object-cover`}
        onError={() => setImgError(true)}
      />
    );
  }

  if (name && name !== 'User') {
    return (
      <div className={`${baseClasses} bg-v11-accent text-v11-accent-text`}>
        {getInitials(name)}
      </div>
    );
  }

  return (
    <div className={`${baseClasses} bg-v11-surface text-v11-text-secondary`}>
      <User className={size === 'sm' ? 'h-3 w-3' : size === 'md' ? 'h-4 w-4' : 'h-5 w-5'} />
    </div>
  );
};
